export default {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  IMAGE: 'IMAGE',
  TEXT_ANIMATION: 'TEXT_ANIMATION',
  WIDGET: 'WIDGET',
  MULTI_WIDGET: 'MULTIWIDGET',
  INTRO_WIDGET: 'INTROWIDGET',
  SVG: 'SVG',
  STATIC_IMAGE: 'STATIC_IMAGE',
  SHAPE: 'SHAPE',
  TEXT: 'TEXT',
  WATERMARK_TEXT: 'WATERMARK_TEXT',
  WATERMARK_IMAGE: 'WATERMARK_IMAGE',
  ZOOM_IN: 'ZOOM_IN',
  ZOOM_OUT: 'ZOOM_OUT',
  LEFT_TOP: 'LEFT_TOP',
  LEFT: 'LEFT',
  LEFT_BOTTOM: 'LEFT_BOTTOM',
  TOP: 'TOP',
  CENTER: 'CENTER',
  BOTTOM: 'BOTTOM',
  RIGHT_TOP: 'RIGHT_TOP',
  RIGHT: 'RIGHT',
  RIGHT_BOTTOM: 'RIGHT_BOTTOM',
  SOLID_COLOR: 'SOLID_COLOR',
  DOUBLE_COLOR: 'DOUBLE_COLOR',
  FIT: 'FIT',
  FILL: 'FILL',
  DE_SELECT_TIMELINE: 'DE_SELECT_TIMELINE',
  ZOOM_CHANGE_END: 'ZOOM_CHANGE_END',
  BACKGROUND: 'BACKGROUND',
  ELEMENT: 'ELEMENT',
  OVERLAY: 'OVERLAY',
  DYNAMIC_LOGO: 'DYNAMIC_LOGO',
  DECORATION_OVERLAY: 'DECORATION_OVERLAY',
}
